export default __webpack_public_path__ + "static/media/img_19.1e3b1e16.jpg";